import React from 'react';
import {
  Box,
  Flex,
  Text,
  Badge,
  VStack,
  useColorModeValue,
} from '@chakra-ui/react';
import {
  MERCH_FULFILLMENT_LABELS,
  getMerchFulfillmentColor,
} from '../../utils/merchFulfillmentLabels';

const FUTURE_STEPS = ['shipped', 'ready_pickup', 'delivered'];

function timelineEntryKey(entry) {
  return [entry.status, entry.at, entry.by || 'system']
    .filter(Boolean)
    .join('::');
}

function MerchOrderFulfillmentTimeline({ merch }) {
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  const muted = useColorModeValue('gray.500', 'gray.400');
  const activeBg = useColorModeValue('orange.50', 'orange.900');

  if (!merch) return null;

  const history = merch.statusHistory || [];
  const currentStatus = merch.fulfillmentStatus || 'paid';

  if (history.length === 0) return null;

  const lastEntryKey = timelineEntryKey(history[history.length - 1]);

  return (
    <Box mt={4}>
      <Text fontSize="sm" fontWeight="semibold" mb={2}>
        Stato evasione merch
      </Text>
      {merch.isPreorder && (
        <Badge colorScheme="orange" mb={3}>
          Prenotato
        </Badge>
      )}
      <VStack align="stretch" spacing={0}>
        {history.map((entry) => {
          const isActive = entry.status === currentStatus;
          const isFuture = FUTURE_STEPS.includes(entry.status) && !isActive;
          const isLast = timelineEntryKey(entry) === lastEntryKey;
          const color = getMerchFulfillmentColor(entry.status);

          return (
            <Flex
              key={timelineEntryKey(entry)}
              gap={3}
              opacity={isFuture ? 0.45 : 1}
            >
              <Flex direction="column" align="center" w="16px" flexShrink={0}>
                <Box
                  w="10px"
                  h="10px"
                  borderRadius="full"
                  bg={isActive ? `${color}.400` : borderColor}
                  mt={1}
                />
                {!isLast && (
                  <Box w="2px" flex={1} bg={borderColor} minH="20px" />
                )}
              </Flex>
              <Box
                flex={1}
                pb={isLast ? 0 : 3}
                px={2}
                py={1}
                borderRadius="md"
                bg={isActive ? activeBg : undefined}
              >
                <Text
                  fontSize="sm"
                  fontWeight={isActive ? 'semibold' : 'medium'}
                >
                  {MERCH_FULFILLMENT_LABELS[entry.status] || entry.status}
                </Text>
                <Text fontSize="xs" color={muted}>
                  {entry.at ? new Date(entry.at).toLocaleString('it-IT') : '—'}
                </Text>
              </Box>
            </Flex>
          );
        })}
      </VStack>
      {currentStatus === 'awaiting_stock' && (
        <Text fontSize="sm" color={muted} mt={3}>
          La tua prenotazione è registrata: la manderemo in stampa a breve.
        </Text>
      )}
      {currentStatus === 'in_print' && (
        <Text fontSize="sm" color={muted} mt={3}>
          Il tuo ordine è in stampa. Ti aggiorneremo quando sarà pronto.
        </Text>
      )}
      {currentStatus === 'preparing' && (
        <Text fontSize="sm" color={muted} mt={3}>
          Il prodotto è pronto: stiamo preparando ritiro o spedizione.
        </Text>
      )}
    </Box>
  );
}

export default MerchOrderFulfillmentTimeline;
